
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import PickerDate from '@/components/picker-date.vue';
	import RadioButton from '@/components/radio-button.vue';
	import {
		providerSelectItem
	} from '@/api/supplier';
  import {
    getSearchDate,
    nextDay
  } from "@/utils" 
  import {
    productscheduleProductList
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
      RadioButton
    }
  })
  export default class ProductList extends Vue {
    private state = 0
    private stateList = [
      {value:0,label:'待审核'},
      {value:1,label:'待上架（已有开团时间，资料还未完善的商品）'},
      {value:2,label:'已放入商品库(资料已完善的商品)'},
    ]
    private keywords = ''
    private supplier = null
    private supplierlist:any = []
    private audit = null
    private auditlist = [
      {value:null,label:'全部'},
      // {value:-1,label:'待提交'},
      {value:1,label:'待审核'},
      {value:0,label:'待完善'},
      {value:3,label:'审核不通过'},
      {value:2,label:'已通过'},
    ]
    private filterTime = ''
    private tablelist:any = []
    private tableloading = false
    private pageNo = 1
    private pageSize = 20
    private total = 0
    private defaultImg = 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/9d444a0d810d7945de8af64ae2cd8a9.png'
    private stateClass = {
      0:'color-f56c6c',
      1:'',
      2:'color-67c23a',
      3:'color-f56c6c'
    }
    private ScheduleProductCheckPermissions = []



    private activated () {
      this.getSupplierList()
      this.gettablelist()
    }



    
    
    private todetails(row,index,type){
      let query:any = {
        id:row.Id,
        index:index,
        flowTab:'',
        type:type
      }
      if(index==4){
        if(row.ProductLogisticsState!=2||row.ProductCheckWarehouseState==2||(row.ProductLogisticsState==2&&row.ProductCheckWarehouseState==0)){
          query.flowTab = '1'
        }else{
          query.flowTab = '2'
        }
      }
      this.$router.push({
        path:'auditScheduleShopDetails',
        query:query
      })
    }
    // 获取供应商列表
		private async getSupplierList() {
			try {
				const res: any = await providerSelectItem({});
				this.supplierlist = res.Result.map(v => {
					return {
						value: v.Id,
						label: v.ProviderName
					}
				})
			} catch (e) {
				console.log('supplierList ===>', e);
			}
		}
    private clearSearch(){
      this.keywords = ''
      this.state = 0
      this.audit = null
      this.supplier = null
      this.filterTime = ''
      this.doSearch()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize,
          Type:this.state,
          State:this.audit,
          ProviderId:this.supplier,
        }
        if(this.filterTime){
          let t = this.filterTime.split('/')
          data.StartTime = t[0]
          data.EndTime = nextDay(t[1],1)
        }
        let res:any = await productscheduleProductList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
          this.ScheduleProductCheckPermissions = res.Result.ScheduleProductCheckPermissions
        }
      }finally{
        this.tableloading = false
      }
    }
  }
